import { deleteProductImage } from '@/api/productImage.api';
import { getProductImageType } from '@/utils/getProductImageType';
import type { IProductImage } from '@/typescript/interfaces/IProductImage';
import type { TSides } from '@/typescript/interfaces/TSide';
import type { TUploadImgType } from '@/typescript/interfaces/TUploadImgType';

async function deleteSelectedProductImage(
    currentSide: TSides,
    uploadImageType: TUploadImgType,
    productImages: IProductImage[],
): Promise<void> {
    const type = getProductImageType(currentSide, uploadImageType);
    const currentImage = productImages.find((img) => img.type === type);
    if (!currentImage) {
        return;
    }
    await deleteProductImage(currentImage.uuid);
}

export { deleteSelectedProductImage };
